import { render, staticRenderFns } from "./projectMeetings.vue?vue&type=template&id=5582dabd&scoped=true&"
import script from "./projectMeetings.vue?vue&type=script&lang=js&"
export * from "./projectMeetings.vue?vue&type=script&lang=js&"
import style0 from "./projectMeetings.vue?vue&type=style&index=0&id=5582dabd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582dabd",
  null
  
)

export default component.exports